module.exports = __webpack_public_path__ + "static/img/logo.c2f6dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/logo.png
// module id = sjlI
// module chunks = 1